<template>
<div>
<sby-profile-card
            :type="cardType"
            :profile="getCurProfile"
            :editable="editable"
            :add-text="addText"
            :view-text="viewText"
            @add="showEditProfile"
            @click="doShowList" class="van-hairline--top" />

      <van-popup v-model="showList" position="bottom">
        <sby-profile-list
          v-model="chosenProfileId"
          :list="profiles"
          @edit="showEditProfile"
          @add="showEditProfile"
          :add-text="addText"
          @select="selectedProfile" />
      </van-popup>

    <van-popup v-model="showEdit" v-if="showEdit" position="bottom">
    <sby-profile-edit  
      @saved="savedProfile"
      @cancel="showEdit = false"
      :editProfile="editProfile"
      :defaultProfile="defaultProfile"
      ></sby-profile-edit>
</van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Button,
  Row,
  Col,
  Field,
  CellGroup,
  Toast,
  Checkbox,
  CheckboxGroup,
  Cell, List, Search,
  Dialog,Rate,
  Icon,Popup,
  SubmitBar,
  Tag,
  Swipe, SwipeItem
} from "vant";

Vue.use(Dialog)
Vue.use(Popup)

export default {
  name: 'profile-card',
  props: {
    text: String,
    viewText: String,
    initProfileId: Number,
    addText: String,
    currentProfile: Object,
    editable: {
      type: Boolean,
      default: true
    },
    myself: false
   },
  data() {
      return {
        showList: false,
        profiles: [],
        editProfile: null,
        model: {},
        chosenProfileId: null,
        showEdit: false,
        profile: null,
        defaultProfile: null,
        isEdit: false,
      }
  },
  watch: {
      currentProfile(val) {
          this.chosenProfileId = this.currentProfile.id
      }
  },
  mounted: function() {
      this.loadProfiles()
      if (this.currentProfile && this.currentProfile.id) {
        this.chosenProfileId = this.currentProfile.id;
      } else if (this.initProfileId) {
        this.chosenProfileId = this.initProfileId;
      }
  },
  computed: {
    getCurProfile() {
      const id = this.chosenProfileId;
      let profile = id !== null ? this.profiles.filter(item => item.id === id)[0] : {};
      return profile
    },
    cardType() {
      return this.chosenProfileId != null ? 'edit' : 'add';
    }
  },
  methods: {
    onClick(event) {
      if (this.editable) {
        this.$emit('click', event);
      }
    },
    
    showEditProfile: function(item) {
      this.editProfile = item
      this.showEdit = true
    },
     selectedProfile: function() {
      this.showList = false;
       for (var index in this.profiles) {
         if (this.profiles[index].id === this.chosenProfileId){
           this.profile = this.profiles[index];
           this.$emit('selected', this.profile)
         }
       }
    },
    loadProfiles() {
      this.$http.get('/api/profile/list')
        .then(response => {
          if (response) {
            this.profiles = response.data.data;
            if (!_.isEmpty(this.profiles)) {//如果资料为空
              if (this.chosenProfileId > 0) {
                for (var index in this.profiles) {
                  if (this.profiles[index].id === this.chosenProfileId){
                    this.profile = this.profiles[index];
                    this.$emit('selected', this.profile);
                  }
                }
              } else if(this.myself && _.isEmpty(this.chosenProfileId) ) {
                for (var index in this.profiles) {
                  if (_.isEmpty(this.profiles[index].relation) || this.profiles.length === 1){
                    this.chosenProfileId = this.profiles[index].id;
                    this.$emit('selected', this.profiles[index])
                    break
                  }
                }
              }
            } else {
              //this.defaultProfile = this.$store.state.user
              //this.showEdit = true;
            }
          }
        });
    },
    doShowList() {
        if (this.editable) {
            this.showList = true
        }
    },
    
    savedProfile: function(profile) {
      this.showEdit = false
      this.showList = false
      this.loadProfiles()
      this.chosenProfileId = profile.id
      this.$emit('selected', profile) 
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/sby-profile.vue